// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2493":"31fd5777","4029":"2dc5cd97","4314":"649948d1","6631":"31fd5777","7474":"188035ae","9861":"29cf8451"}[chunkId] + ".chunk.css";
};